export const CREATION_NAVIGATION_PROMPT = 'creation-request-navigation';
let handler: ((complete: (allow: boolean) => void) => void) | undefined;

export const registerCreationConfirmation = (callback: NonNullable<typeof handler>): (() => void) => {
    handler = callback;
    return () => {
        if (handler === callback) handler = undefined;
    };
};

// History owns the original PUSH/REPLACE/POP continuation, including Forward.
// Complete that continuation rather than guessing a browser-history delta.
export const confirmAppNavigation = (message: string, complete: (allow: boolean) => void): void => {
    if (message === CREATION_NAVIGATION_PROMPT) {
        if (handler) handler(complete);
        else complete(false);
    } else {
        complete(window.confirm(message));
    }
};
